import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-botony',
  templateUrl: './botony.component.html',
  styleUrls: ['./botony.component.scss']
})
export class BotonyComponent implements OnInit {
  botony:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.botony=this.facultyService.getBotony();
  }

}
